<template>
	<div class="audit-upload-card">
		<div class="audit-upload-card__title">
			<span class="audit-upload-card__required" v-if="required">*</span>{{ title }}
			<span
				class="audit-upload-card__action"
				v-if="exampleList && exampleList.length"
				@click="showExample = true"
			>查看示例</span>
		</div>
		<div class="audit-upload-card__body">
			<base-upload
				v-model="fileList"
				:limit="limit"
				:disabled="disabled"
				:repeat-upload="false"
				@success="handleSuccess"
			/>
			<div class="audit-upload-card__desc" v-if="desc">{{ desc }}</div>
			<!-- 卫健委查询链接 -->
			<div class="audit-upload-card__wjw" v-if="showWjw">
				<div class="audit-upload-card__wjw-desc">若无纸质材料，可从下方卫健委官方链接查询并截图上传</div>
				<div class="audit-upload-card__wjw-link">
					<span class="audit-upload-card__wjw-text">https://gjdzhzc.wsb003.cn/Home/CountryIndex</span>
					<van-button type="primary" size="small" @click="copyText">复制上传</van-button>
				</div>
			</div>
		</div>
		<!-- 示例弹层 -->
		<van-action-sheet v-model="showExample" :title="exampleTitle" close-on-click-action>
			<div class="audit-upload-card__example">
				<div class="audit-upload-card__example-desc">{{ exampleDesc }}</div>
				<template v-for="(img, i) in exampleList">
					<div class="audit-upload-card__example-label" :key="'label' + i">{{ exampleLabels[i] || '' }}</div>
					<img :key="'img' + i" :src="img" class="audit-upload-card__example-img" @click="previewExample(img)" />
				</template>
			</div>
		</van-action-sheet>
	</div>
</template>

<script>
import { ImagePreview } from 'vant'

// 多图上传卡片（对应小程序 upload / employmentPhoto / titlePhoto 字段）
export default {
	name: 'AuditUploadCard',
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		title: {
			type: String,
			default: '',
		},
		required: {
			type: Boolean,
			default: false,
		},
		limit: {
			type: [Number, String],
			default: 10,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		desc: {
			type: String,
			default: '',
		},
		showWjw: {
			type: Boolean,
			default: false,
		},
		exampleTitle: {
			type: String,
			default: '',
		},
		exampleDesc: {
			type: String,
			default: '',
		},
		exampleLabels: {
			type: Array,
			default: () => [],
		},
		exampleList: {
			type: Array,
			default: () => [],
		},
	},
	data: () => ({
		showExample: false,
	}),
	computed: {
		fileList: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			},
		},
	},
	methods: {
		handleSuccess() {
			this.$toast('上传成功')
		},
		previewExample(url) {
			ImagePreview([url])
		},
		copyText() {
			const text = 'https://gjdzhzc.wsb003.cn/Home/CountryIndex'
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard
					.writeText(text)
					.then(() => this.$toast('复制成功'))
					.catch(() => this.$toast('复制失败，请检查权限是否开启'))
				return
			}
			const textarea = document.createElement('textarea')
			textarea.value = text
			document.body.appendChild(textarea)
			textarea.select()
			try {
				document.execCommand('copy')
				this.$toast('复制成功')
			} catch (e) {
				this.$toast('复制失败，请检查权限是否开启')
			}
			document.body.removeChild(textarea)
		},
	},
}
</script>

<style lang="less" scoped>
.audit-upload-card {
	background-color: #fff;

	&__title {
		position: relative;
		padding: 14px 16px;
		font-size: 15px;
		font-weight: 500;
		color: #1f2329;
		border-bottom: 1px solid #f5f6f7;
	}

	&__required {
		margin-right: 2px;
		color: #fa5151;
	}

	&__action {
		position: absolute;
		right: 16px;
		font-size: 13px;
		font-weight: normal;
		color: var(--color-primary);
	}

	&__body {
		padding: 14px 16px;
	}

	&__desc {
		margin-top: 10px;
		font-size: 12px;
		line-height: 18px;
		color: #8f959e;
	}

	&__wjw {
		margin-top: 10px;

		&-desc {
			font-size: 12px;
			color: #fa5151;
		}

		&-link {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 6px;
			padding: 6px 10px;
			border-radius: 4px;
			background-color: #f5f6f7;
		}

		&-text {
			padding-right: 10px;
			font-size: 12px;
			line-height: 18px;
			color: #646a73;
			word-break: break-all;
		}
	}

	&__example {
		padding: 16px;

		&-desc {
			font-size: 13px;
			line-height: 20px;
			color: #8f959e;
		}

		&-label {
			margin: 16px 0 8px;
			font-size: 14px;
			font-weight: 500;
			color: #1f2329;
		}

		&-img {
			width: 100%;
			vertical-align: middle;
		}
	}
}
</style>
